import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Markdown from "react-markdown";
import { useEULA, useAcceptEULA } from "@seabrookstudios/pitch2table";
import { useSnackbar } from "notistack";
import { CircularProgressSize } from "../theme";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").EULAVersion} props.eulaVersion
 * @param {() => void} props.onAccepted
 */
export const EulaDialog = ({ eulaVersion, onAccepted }) => {
  const { data: eula, isLoading, isError } = useEULA(eulaVersion);
  const acceptEula = useAcceptEULA();
  const { enqueueSnackbar } = useSnackbar();

  const onAccept = async () => {
    try {
      await acceptEula.mutateAsync(eulaVersion);
      onAccepted();
    } catch {
      enqueueSnackbar("Unable to accept the End User License Agreement. Please try again.", {
        variant: "error",
      });
    }
  };

  return (
    <Dialog open disableEscapeKeyDown onClose={() => {}} aria-labelledby="eula-dialog-title">
      <DialogTitle id="eula-dialog-title">
        <Typography variant="h5" component="div">
          End User License Agreement
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {isLoading && (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress size={CircularProgressSize} />
          </Box>
        )}
        {isError && (
          <Typography color="error">Unable to load the End User License Agreement. Please refresh the page.</Typography>
        )}
        {eula?.text && (
          <Box>
            <Markdown>{eula.text}</Markdown>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button variant="contained" onClick={onAccept} disabled={isLoading || isError || acceptEula.isPending}>
          {acceptEula.isPending ? <CircularProgress size={CircularProgressSize} color="inherit" /> : "Accept"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
